import { action, makeObservable, observable } from "mobx";
import { inject, injectable } from "inversify";
import { IntegrationsStore } from "./IntegrationsStore";
import { FrontLogger } from "@whatslly/commons/frontLogger/frontLogger";
import { backgroundClient } from "@whatslly/commons/background/client";
import { BgCommands } from "@whatslly/commons/bgCommands";

@injectable()
export class AuthStore {
  isAuthenticated?: boolean;
  private logger: FrontLogger;

  constructor(@inject(IntegrationsStore) private integrationsStore: IntegrationsStore, @inject(FrontLogger) private loggerService: FrontLogger) {
    this.logger = this.loggerService.getLogger("auth-store");
    makeObservable(this, {
      isAuthenticated: observable,
      logout: action,
    });
  }

  logout() {
    backgroundClient
      .send(BgCommands.LOGOUT)
      .then(() => {
        this.logger.info("logout successfully");
      })
      .catch((err) => {
        this.logger.error({ err }, "failed to logout from server");
      });
    this.isAuthenticated = false;
    this.integrationsStore.activeIntegrations = {};
  }
}
